import React from 'react';
import PropTypes from 'prop-types';
import ErrorList from '../../../../common/components/ErrorList';

export default class BaseActionHandler extends React.Component {
  static propTypes = {
    action: PropTypes.func,
    data: PropTypes.array,
    condition: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    forceUpdate: PropTypes.bool,
    children: PropTypes.func,
    name: PropTypes.string,
  };
  state = {
    result: null,
    isExecuting: false,
  };

  componentDidMount() {
    this.executeAction(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const conditionValue = this.resolveCondition(this.props.condition);
    const nextConditionValue = this.resolveCondition(nextProps.condition);
    if (
      nextProps.forceUpdate ||
      conditionValue !== nextConditionValue ||
      (!this.props.action && nextProps.action)
    ) {
      this.executeAction(nextProps);
    }
  }

  resolveCondition = condition => {
    if (typeof condition === 'function') {
      const { result, isExecuting } = this.state;
      return condition({ result, isExecuting });
    } else {
      return condition;
    }
  };

  executeAction = ({ action, condition = true, data = [] }) => {
    const conditionValue = this.resolveCondition(condition);

    // only call action if:
    //   the condition is true
    //   the action is a function
    if (typeof action === 'function' && conditionValue) {
      this.setState(prevState => ({
        ...prevState,
        isExecuting: true,
      }));
      action(...data)
        .then(result => {
          let resp, json;
          if (result.payload) {
            // if FSA action
            resp = result.payload.resp;
            json = result.payload.json;
          } else {
            // if not FSA action
            resp = result.resp;
            json = result.json;
          }
          if (resp && json) {
            if (resp.ok) {
              this.updateResult({ result });
            } else {
              // handle service generated errors
              this.updateResult({ result, error: true });
            }
          } else {
            // handle non service generated errors
            this.updateResult({ result, error: true });
          }
        })
        .catch(result => {
          this.updateResult({ result, error: true });
        });
    }
  };

  updateResult = ({ result, error = false }) => {
    let actionResult = result;
    if (error) {
      let resp, json, status, message;
      if (result && result.payload && typeof result.payload === 'object') {
        resp = result.payload.resp;
        json = result.payload.json;
      } else if (typeof result === 'object') {
        resp = result.resp;
        json = result.json;
        if (!resp && !json) {
          message = result.toString();
        }
      } else if (typeof result === 'string') {
        message = result;
      }
      if (resp) {
        status = resp.status;
      }
      if (json) {
        message = json.message;
      }
      actionResult = {
        error: message,
        status,
        hasError: true,
      };
    }

    this.setState(prevState => {
      return {
        ...prevState,
        result: actionResult,
        isExecuting: false,
      };
    });
  };

  render() {
    const { action, children } = this.props;
    const { result } = this.state;
    const shouldRenderChildren =
      typeof action === 'function' && typeof children === 'function';

    if (result && result.hasError) {
      return (
        <div>
          <ErrorList
            errors={result.error ? [result.error] : ['An error has occurred']}
          />
          {shouldRenderChildren ? children(result) : null}
        </div>
      );
    }
    if (shouldRenderChildren) {
      return children(result);
    }

    if (__DEV__ && typeof action !== 'function') {
      // eslint-disable-next-line no-console
      console.warn(
        'WARNING: Invalid action type passed to ActionHandler. Actions must be an object and should not be null or undefined.'
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/account/components/ActionHandler/BaseActionHandler.js